export default function callback(temp, body, status, headers) {
  const cb = {
    temp: null,
    body,
    status,
    headers,
  };
  return cb;
}



// WEBPACK FOOTER //
// ./src/api/callback.js